export default __webpack_public_path__ + "static/media/87.c0202e8c.jpeg";